import { render, staticRenderFns } from "./WeightInput.vue?vue&type=template&id=288eaf8e&scoped=true"
import script from "./WeightInput.vue?vue&type=script&lang=ts"
export * from "./WeightInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288eaf8e",
  null
  
)

export default component.exports